import { render, staticRenderFns } from "./PersonalizedGameEditorNumber.vue?vue&type=template&id=32b9e715&scoped=true&"
import script from "./PersonalizedGameEditorNumber.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b9e715",
  null
  
)

export default component.exports